export default "__VITE_ASSET__c59827ff__"